/**
 * Centralized brand color tokens for MiDash. Import these wherever you need
 * hero gradients, glow effects, or accent hues so the palette stays consistent.
 */

export const HERO_GRADIENT = "linear-gradient(135deg, #6dd8d0, #4db8b0)";
export const HERO_GRADIENT_STOPS = ["#6dd8d0", "#4db8b0"] as const;

export const HERO_ACCENT_LIGHT = "#6dd8d0";
export const HERO_ACCENT = "#5bc9c1";
export const HERO_ACCENT_DEEP = "#4db8b0";
export const HERO_ACCENT_DARK = "#3f9da1";
export const HERO_ICON_DEEPEST = "#0b2e32";

export const HERO_GLOW_LIGHT = "rgba(109, 216, 208, 0.18)";
export const HERO_GLOW_BORDER = "rgba(91, 201, 193, 0.35)";
export const HERO_GLOW_SHADOW = "rgba(63, 157, 161, 0.25)";
export const HERO_GLOW_SHADOW_STRONG = "rgba(63, 157, 161, 0.36)";

export const BRAND_POSITIVE = "#2ddab2";
export const BRAND_NEUTRAL = "#7f8f8c";
export const BRAND_NEGATIVE = "#ff6f91";

export const BRAND_COLORS = {
  hero: {
    gradient: HERO_GRADIENT,
    gradientStops: HERO_GRADIENT_STOPS,
    accentLight: HERO_ACCENT_LIGHT,
    accent: HERO_ACCENT,
    accentDeep: HERO_ACCENT_DEEP,
    accentDark: HERO_ACCENT_DARK,
    iconDeepest: HERO_ICON_DEEPEST,
  },
  glow: {
    light: HERO_GLOW_LIGHT,
    border: HERO_GLOW_BORDER,
    shadow: HERO_GLOW_SHADOW,
    shadowStrong: HERO_GLOW_SHADOW_STRONG,
  },
  sentiment: {
    positive: BRAND_POSITIVE,
    neutral: BRAND_NEUTRAL,
    negative: BRAND_NEGATIVE,
  },
} as const;

export type BrandColorGroup = typeof BRAND_COLORS;
